import React from 'react';
import { gql, useApolloClient, useQuery } from '@apollo/client';
import { useI18n } from '~Hooks';
import { ItemNameQuery, ItemNameQueryVariables } from './__queries__/ItemNameQuery';
import { itemInBong } from '~Scenes/POS/Queries/__queries__';
import { ITEM_FRAGMENT } from '~Scenes/POS/Queries/query';

export const ITEM_NAME_QUERY = gql`
  query ItemNameQuery($id: ID!) {
    item: Item(id: $id) {
      id
      titleLang {
        id
        se
        en
        es
        no
      }
    }
  }
`;

interface Props {
  id: string;
}

/* Responsible for displaying the name of the product - if we're on the settings page, we display a mock name */
const ItemName: React.FC<Props> = ({ id }) => {
  const { i18n } = useI18n();
  const client = useApolloClient();

  const itemFragment = client.readFragment<itemInBong>({
    id: `Item${id}`,
    fragment: ITEM_FRAGMENT,
  });

  const query = useQuery<ItemNameQuery, ItemNameQueryVariables>(ITEM_NAME_QUERY, {
    variables: {
      id,
    },
    fetchPolicy: 'cache-first',
    skip: id === 'mock-id', // Derives from OrderMock.tsx which is used in KDS settings
  });

  if (id === 'mock-id') {
    return <span>{i18n('KDS.Order.Mock.DisplayName')}</span>;
  }

  if (itemFragment) {
    return <span>{i18n(itemFragment.titleLang)}</span>;
  }

  return <span>{query.data?.item ? i18n(query.data.item.titleLang) : id}</span>;
};

export default React.memo(ItemName);
